export enum ButtonColor {
    White = 'white',
    Blue = 'blue',
    Red = 'red',
}

export enum ButtonTag {
    Anchor = 'a',
    Button = 'button',
    RouterLink = 'router-link',
}

export enum ButtonSize {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
}

export enum ButtonType {
    Button = 'button',
    Submit = 'submit',
}
